import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api/api';
import RecipeDisplay from '../components/RecipeDisplay';
import Seo from '../components/Seo';

const RecipeDetailPage = () => {
  const { recipeId } = useParams();
  const [recipe, setRecipe] = useState(null);
  const [familyTree, setFamilyTree] = useState(null); // Pour l'arbre de recettes
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
      dish: [],
      preparationTime: 30,
      bakingTime: 30,
      cuisine: [],
      complexity: [],
      ingredients: [],
      description: ''
  });
  //Creer les etats adults, teens et children
  const [adults, setAdults] = useState(2);
  const [teens, setTeens] = useState(0);
  const [children, setChildren] = useState(0);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const heroImage = recipe?.imgUrlArray?.[0] || recipe?.imageUrl || recipe?.coverImage || '/img/idees_repas_personnalisees.png';
  const metaTitle = recipe?.title ? `${recipe.title}` : 'Recette YAQAM';
  const metaDescription = recipe?.description
    ? recipe.description.slice(0, 155)
    : 'Découvrez cette recette générée par YAQAM et adaptez-la selon vos préférences.';

  const seo = (
    <Seo
      title={metaTitle}
      description={metaDescription}
      image={heroImage}
      breadcrumb
      type="article"
      noindex={!recipe}
    />
  );

  useEffect(() => {
    const fetchRecipe = async () => {
      try {
        const response = await api.get(`/api/meals/recipe/${recipeId}`);
        setRecipe(response.data.data.recipe);
        setFamilyTree(response.data.data.familyTree); // Met à jour l'arbre de recettes
      } catch (error) {
        console.error('Error fetching recipe:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRecipe();
  }, [recipeId]);

  if (isLoading) {
    return (
      <>
        {seo}
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#87A96B]"></div>
        </div>
      </>
    );
  }

  if (!recipe) {
    return (
      <>
        {seo}
        <div className="text-center text-[#2C3E50]">Recette non trouvée</div>
      </>
    );
  }
  const handleVariantRequest = async (selectedVariants) => {
    setIsLoading(true);
    try {
      const response = await api.post('/api/meals/iterate-recipe', {
        originalRecipe: recipe,
        variants: selectedVariants,
        oldFamilyTree: familyTree // Envoie l'arbre de recettes actuel
      });
      //REDIRECT TO THE NEW RECIPE
      window.location.href = `/recette/${response.data.recipe.id}`;
      console.log("Response from iterate-recipe:", response.data);
      // setRecipe(response.data.recipe);
      // setFamilyTree(response.data.familyTree); // Met à jour l'arbre de recettes
    } catch (error) {
      console.error("Erreur:", error);
      if (!(error?.response && error.response.status === 429)) {
        alert("Une erreur est survenue lors de la génération de la variante.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const updateRecipe = async (recipe) => {
    if (!recipe) return;
    
    try {
      recipe.updatedAt=new Date()
      recipe.status="readyToCook"
      recipe.familySize={
        adults: adults,
        teens: teens,
        children: children
      }
      console.log("Updating recipe with family size:", recipe.familySize);
      api.post(`/api/users/update-user-list`, {
          recipe: recipe,
          typeList:"readyToCook"
      })
      await api.post('/api/meals/update-recipe', {
        recipe: recipe
      });
      
      setShowSuccessPopup(true);
    } catch (error) {
      console.error("Erreur:", error);
      alert("Une erreur est survenue lors de la sauvegarde de la recette.");
    }
  };

  return (
    <>
      {seo}
      <div className="max-w-4xl px-4">
        <RecipeDisplay
            recipe={recipe}
            onSave={updateRecipe}
            onNew={() => setRecipe(null)}
            onVariantRequest={handleVariantRequest}
            familyTree={familyTree}
            changeAdults={setAdults}
            changeTeens={setTeens}
            changeChildren={setChildren}
          />
        {showSuccessPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 max-w-sm w-full text-center border border-gray-100">
              <h2 className="text-lg font-bold mb-4 text-[#2C3E50]">Recette sauvegardée avec succès !</h2>
              <p className="mb-6 text-[#2C3E50]">Voulez-vous aller à la page "Mes recettes" ou continuer sur cette page ?</p>
              <div className="flex justify-center gap-4">
                <button
                  className="px-4 py-2 bg-[#87A96B] text-white rounded hover:bg-[#87A96B]/90 transition-colors font-medium"
                  onClick={() => window.location.href = '/mes-recettes'}
                >
                  Aller à mes recettes
                </button>
                <button
                  className="px-4 py-2 bg-[#2C3E50] text-white rounded hover:bg-[#2C3E50]/90 transition-colors font-medium"
                  onClick={() => setShowSuccessPopup(false)}
                >
                  Continuer ici
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default RecipeDetailPage;
